<script>
  import { onDestroy } from 'svelte';
  import { sessionStore } from '../stores';
  import { costStore } from '../stores/costStore';
  import { serviceStore } from '../stores/serviceStore';
  import { downloadFile } from '../utils/imageUtils';
  import { constructUrl } from '../utils/apiClient';
  import { request } from '../utils/request';
  import { requestLogin, refreshBalance } from '../utils/authSession';
  import { assertServiceAvailable } from '../utils/serviceAvailability';
  import { startBackgroundUpscale, waitForCreation } from '../utils/galleryRequests';
  import { downloadEmoticons } from '../utils/emoticonDownload';
  import PublishResult from './PublishResult.svelte';
  export let image = '';
  export let task = {};
  export let showDownload = true;
  let busy = false, error = '', processed = '', lastImage = '', controller;
  $: if (image !== lastImage) { controller?.abort(); lastImage = image; processed = ''; error = ''; }
  $: options = task.options || task.editHistory?.at(-1)?.settings || {};
  $: style = options.style || options.selectedStyle || '';
  $: emoticon = ['emoticon_style', 'realistic_emoticon_style'].includes(task.featureId) || ['이모티콘', '애니 이모티콘', '실사 이모티콘', '말랑 스티커 이모티콘'].includes(style);
  async function process(upscale = false) {
    if (busy || !await requestLogin('결과를 가공하려면 로그인해 주세요.')) return;
    busy = true; error = ''; controller = new AbortController();
    const currentImage = image;
    try {
      await assertServiceAvailable();
      let url;
      if (upscale) {
        const initial = await startBackgroundUpscale($sessionStore.userId, task.process_id, controller.signal);
        const result = await waitForCreation(initial, controller.signal); url = result.result_url;
      } else {
        const result = await request('/api/remove_background_from_url', { method: 'POST', signal: controller.signal, body: { image_url: image, session_id: $sessionStore.sessionId } });
        url = result.download_url || result.result_url;
      }
      if (image !== currentImage) return;
      processed = constructUrl(url); await downloadFile(processed, `erion_transparent_${Date.now()}.png`);
      document.dispatchEvent(new CustomEvent('galleryChanged'));
    } catch (e) { if (e.name !== 'AbortError') error = e.message; }
    finally { busy = false; refreshBalance().catch(() => {}); }
  }
  async function split() {
    if (busy) return;
    busy = true; error = '';
    try { await downloadEmoticons(processed || image); } catch (e) { error = e.message; } finally { busy = false; }
  }
  onDestroy(() => controller?.abort());
</script>
<div class="result-tools">
  {#if showDownload}<button disabled={busy} on:click={() => downloadFile(image, `erion_${Date.now()}.png`)}>원본 결과 다운로드</button>{/if}
  {#if task.backgroundUpscaleSupported && task.process_id}
    <button disabled={busy || $serviceStore.blocksNewRequests} on:click={() => process(true)}>{busy ? '처리 중...' : `투명 배경·고화질 PNG · ${$costStore.background_upscale ?? 1} RION`}</button>
  {:else if task.featureId && !['remove_background', 'remove_background_from_url', 'background_upscale', 'make_video'].includes(task.featureId)}
    <button disabled={busy || $serviceStore.blocksNewRequests} on:click={() => process()}>{busy ? '처리 중...' : `배경 제거 다운로드 · ${$costStore.remove_background ?? 1} RION`}</button>
  {/if}
  {#if processed}<button on:click={() => downloadFile(processed, 'erion_transparent.png')}>투명 PNG 다시 다운로드</button>{/if}
  {#if emoticon}<button disabled={busy} on:click={split}>이모티콘 12장 ZIP 다운로드</button>{/if}
  <PublishResult {image} feature={task.featureId} {options} />
</div>
{#if error}<p role="alert">{error}</p>{/if}
<style>
  .result-tools { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; padding: 14px 0; }
  button { padding: 9px 14px; font: inherit; font-size: .85rem; color: inherit; background: transparent; border: 1px solid #8885; border-radius: 10px; cursor: pointer; } button:disabled { opacity: .5; cursor: default; } [role=alert] { color: #c9442f; }
</style>
